var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpressiveMomentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1294.4584,
    y1: -1378.5916,
    x2: 2571.6677,
    y2: 2487.5347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BB2D24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2371,
    style: {
      stopColor: "#C3342C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D84744"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454,79.5c-47.7-47.7-125-47.7-172.7,0L250,110.8l-31.3-31.3C171,31.8,93.7,31.8,46,79.5s-47.7,125,0,172.7 l31.3,31.3l61.8,61.8l64.9-64.9L38.7,188.4c-3.7-2.1-4.4-7.1-1.4-10.1c8.4-8.4,20.3-12.2,32-10.3l56.4,9.3l12.8-12.8 c5.3-5.3,14-5.3,19.4,0c5,5,5.3,12.9,0.9,18.2l16.5,2.7l23.1,3.8l14.1-14.1c5.3-5.3,14-5.3,19.4,0c5.3,5.3,5.3,14,0,19.4l-0.3,0.3 l49.7,8.2l30.5-30.5l5-5c21.6-21.6,48.8-36.9,78.6-44.1c8.8-2.1,16.7,5.8,14.6,14.6c-7.2,29.7-22.4,56.9-44.1,78.6l-5,5l-30.5,30.5 l8.2,49.7l0.3-0.3c5.3-5.3,14-5.3,19.4,0c5.3,5.3,5.3,14,0,19.4l-14.1,14.1l3.8,23.1l74.8-74.8l31.3-31.3 C501.7,204.5,501.7,127.2,454,79.5z M188.2,394.4l61.8,61.8l47.3-47.3L253,329.6L188.2,394.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressiveMomentIcon);
export default __webpack_public_path__ + "static/media/impressive_moment_icon.7041ab1d4ed9ffb5267b13001b34d341.svg";
export { ForwardRef as ReactComponent };